import { render, staticRenderFns } from "./ButtonSwitcher.vue?vue&type=template&id=63ef8c23&scoped=true"
import script from "./ButtonSwitcher.vue?vue&type=script&lang=js"
export * from "./ButtonSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ButtonSwitcher.vue?vue&type=style&index=0&id=63ef8c23&prod&lang=css"
import style1 from "./ButtonSwitcher.vue?vue&type=style&index=1&id=63ef8c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef8c23",
  null
  
)

export default component.exports